import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type {
  StreaksResponse,
  WeeklyGoalData,
  HealthDashboardData,
  SingleContactStreak,
} from '@/lib/types'

export function useStreaks() {
  return useQuery({
    queryKey: ['gamification', 'streaks'],
    queryFn: () => api<StreaksResponse>('/api/gamification/streaks'),
  })
}

export function useWeeklyGoal(goal?: number) {
  const qs = goal ? `?goal=${goal}` : ''
  return useQuery({
    queryKey: ['gamification', 'weekly-goal', goal],
    queryFn: () => api<WeeklyGoalData>(`/api/gamification/weekly-goal${qs}`),
  })
}

export function useHealthDashboard() {
  return useQuery({
    queryKey: ['gamification', 'health-dashboard'],
    queryFn: () => api<HealthDashboardData>('/api/gamification/health-dashboard'),
  })
}

export function useContactStreak(contactId: string | undefined) {
  return useQuery({
    queryKey: ['gamification', 'contact-streak', contactId],
    queryFn: () => api<SingleContactStreak>(`/api/contacts/${contactId}/streak`),
    enabled: !!contactId,
  })
}
